import { InvoiceTextClockIcon } from './InvoiceTextClockIcon';

/**
 * author: Jeff Anders
 * id 52B9052B-EA7E-4016-9BBC-14FB91CE07EE
 * name invoice-text-clock
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-text-clock.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceTextScheduledIcon = InvoiceTextClockIcon;
export default InvoiceTextScheduledIcon